module.exports = __webpack_public_path__ + "static/media/pexels-maria-orlova-4969918.f529034e.42b9dbe6.jpg";